module.exports = __webpack_public_path__ + "static/card-section-1-15d0bc2c35294d7ced973fcff9e3150e.jpg";